import { some, filter } from 'lodash/collection'

export const ROLES = {
  OBSERVATOR: parseInt(process.env.VUE_APP_IAM_OBSERVATOR_LEVEL) || 5,
  COLLABORATOR: parseInt(process.env.VUE_APP_IAM_COLLABORATOR_LEVEL) || 10,
  MEMBER: parseInt(process.env.VUE_APP_IAM_MEMBER_LEVEL) || 20,
  MANAGER: parseInt(process.env.VUE_APP_IAM_MANAGER_LEVEL) || 30,
  OWNER: parseInt(process.env.VUE_APP_IAM_OWNER_LEVEL) || 50
}

export const exactLevel = (organizationId, claims, level) => {
  return some(
    claims,
    (claim) => claim.id === organizationId && claim.type === 'organization' && claim.attribution === level
  )
}
export const minimalLevel = (organizationId, claims, level) => {
  return some(
    claims,
    (claim) => claim.id === organizationId && claim.type === 'organization' && claim.attribution >= level
  )
}
export const maximalLevel = (organizationId, claims, level) => {
  return some(
    claims,
    (claim) => claim.id === organizationId && claim.type === 'organization' && claim.attribution <= level
  )
}

const matchClaimToPolicy = (claim, policy) => {
  if (policy.organization_id === claim.id) {
    return policy.attribution <= claim.attribution
  }
  return true
}

export const filterPolicies = (claims, policies) => {
  // find the organizations we're in and filter the policies that <= our attribution
  let match = claims.find((x) => x.type === 'organization')
  if (!match) return policies
  return filter(policies, (p) => matchClaimToPolicy(match, p))
}

const matchKey = (policy, key, value) => {
  return policy[key] && (policy[key] === '*' || policy[key] === value)
}

const matchPolicy = (policy, action, scope) => {
  return matchKey(policy, 'scope', scope) && matchKey(policy, 'action', action)
}

export const checkPermission = (policies, permissionString) => {
  const [scope, action] = permissionString.split(':')
  return some(policies, (policy) => matchPolicy(policy, action, scope))
}

// TODO:  remove this function
// use the OrgUser/GroupUser with included `user` and `account` directly instead
export const addAttributionInfo = (users, attributions) => {
  return users
    .map((match) => {
      let attribution = attributions.find((attr) => attr.value === match.attribution)
      if (match && attribution) {
        return {
          ...match.user,
          attribution: attribution.value,
          attributionName: attribution.name
        }
      }
    })
    .filter((el) => !!el)
}
